import React, { useState, useEffect } from "react"
import { AiFillEye, AiFillGithub } from "react-icons/ai"
import { motion } from "framer-motion"
import { Modal } from "rsuite"
import { MotionWrapper, SectionWrapper } from "../../components"
import { urlFor, client } from "../../client"
import "./Work.scss"
import BaseEntity from "../../core/BaseEntity"

interface Work extends BaseEntity {
	projectLink: string
	codeLink: string
	tags: string[]
	description_es: string
}

const Work = () => {
	const [showDescriptionModal, setShowDescriptionModal] = useState(false)
	const [selectedWork, setSelectedWork] = useState<Work>()
	const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 })
	const [works, setWorks] = useState([] as Work[])
	const [filterWork, setFilterWork] = useState([] as Work[])

	useEffect(() => {
		const query = '*[_type == "works"]'

		client.fetch(query).then((data) => {
			setWorks(data)
			setFilterWork(data)
		})
	}, [])

	const onShowDescription = (data: Work) => {
		setSelectedWork(data)
		console.log("")
		setShowDescriptionModal(true)
	}

	return (
		<>
			<h2 className='head-text'>
				<span>Projects</span> i've worked on
			</h2>

			<motion.div animate={animateCard} transition={{ duration: 0.5, delayChildren: 0.5 }} className='app__work-portfolio'>
				{filterWork.map((work, index) => (
					<div className='app__work-item' key={index}>
						<div className='app__work-img app__flex'>
							<img src={urlFor(work.imgUrl).toString()} alt={work.title} />
							<motion.div whileHover={{ opacity: [0, 1] }} transition={{ duration: 0, ease: "easeInOut", staggerChildren: 0.5 }} className='app__work-hover app__flex'>
								{work.projectLink && (
									<a href={work.projectLink} target='_blank' rel='noreferrer'>
										<motion.div whileInView={{ scale: [0, 1] }} whileHover={{ scale: [1, 0.9] }} transition={{ duration: 0.25 }} className='app__flex'>
											<AiFillEye />
										</motion.div>
									</a>
								)}
								{work.codeLink && (
									<a href={work.codeLink} target='_blank' rel='noreferrer'>
										<motion.div whileInView={{ scale: [0, 1] }} whileHover={{ scale: [1, 0.9] }} transition={{ duration: 0.25 }} className='app__flex'>
											<AiFillGithub />
										</motion.div>
									</a>
								)}
							</motion.div>
						</div>

						<div className='app__work-content app__flex'>
							<h4 className='bold-text'>{work.title}</h4>
							<div className='app__description-container' onClick={() => onShowDescription(work)}>
								<p className='p-text app__description' style={{ marginTop: 10 }}>
									{work.description}
								</p>
								<p className='p-text app__description' style={{ marginTop: 10, fontStyle: "italic" }}>
									{work.description_es}
								</p>
							</div>
							<div className='app__work-tag app__flex'>
								{work.tags.map((item, index) => (
									<p className='p-text' key={index}>
										{`#${item}`}&nbsp;
									</p>
								))}
							</div>
						</div>
					</div>
				))}
			</motion.div>
			<Modal open={showDescriptionModal} onClose={() => setShowDescriptionModal(false)}>
				<Modal.Header>Description / Descripción</Modal.Header>
				<Modal.Body>
					<p className='p-text app__description' style={{ marginTop: 10 }}>
						{selectedWork?.description}
					</p>
					<p className='p-text app__description' style={{ marginTop: 10, fontStyle: "italic" }}>
						{selectedWork?.description_es}
					</p>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default SectionWrapper(MotionWrapper(Work, "app__works"), "work", "app__primarybg")
